export default "__VITE_ASSET__3a74e231__"